import React from 'react';

export const buildStepEyebrow = ({ stepIndex, stepCount, stepLabel } = {}) => {
    const label = String(stepLabel || '').trim();
    const index = Number(stepIndex);
    const count = Number(stepCount);

    if (!Number.isFinite(index) || index < 1) {
        return label || null;
    }

    if (!Number.isFinite(count) || count < index) {
        return label ? `Step ${index} · ${label}` : `Step ${index}`;
    }

    return label ? `Step ${index} of ${count} · ${label}` : `Step ${index} of ${count}`;
};

const DocumentFirstStepHead = ({
    stepIndex,
    stepCount,
    stepLabel,
    title,
    intro,
    dataTestId = 'business-v2-document-first-step-head',
}) => {
    const eyebrow = buildStepEyebrow({ stepIndex, stepCount, stepLabel });

    if (!eyebrow && !title && !intro) return null;

    return (
        <div className='docfirst__step-head' data-testid={dataTestId}>
            {eyebrow ? (
                <div className='docfirst__eyebrow' data-testid={`${dataTestId}-eyebrow`}>{eyebrow}</div>
            ) : null}
            {title ? (
                <h2 className='docfirst__title' data-testid={`${dataTestId}-title`}>{title}</h2>
            ) : null}
            {intro ? (
                <p className='docfirst__intro'>{intro}</p>
            ) : null}
        </div>
    );
};

export default DocumentFirstStepHead;

